export const normalizeAccountStatusDialogData = (data) => {
  const safeData = data ?? {};
  const reason = safeData.reason ?? safeData.lockAccountType ?? "";
  return {
    ...safeData,
    status: safeData.status ?? "",
    reason,
    lockAccountType: safeData.lockAccountType ?? reason,
    remark: safeData.remark ?? "",
  };
};

